module.exports = __webpack_public_path__ + "img/bottomicon (1).ae3407a3.png";